// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"103":"81f95583","531":"045dae41","645":"562d3704","818":"2d66bf1e"}[chunkId] + ".chunk.css";
};